import { INetHandler } from './IMNetHandler';
import { net } from './pb';
import C2S from './IMC2S';
import GameSocket from './IMGameSocket';
import StringUtils from './IMStringUtils';
import SingleCountEmitter, { IMEvent } from './IMEventEmitter';
import IMApp from './IMApp';
import IMApis from './IMApis';
import IMPinyin from './IMPinyin'
import IMUsers from './IMUsers';
import MessageType from './IMMessageType'
import IMConversation from './IMConversation';
import IMGroups from './IMGroups';
import IMMessage from './IMMessage';
import IMEventEmitter from './IMEventEmitter';
import { ms } from 'date-fns/locale';
import AppData from '../model/AppData';
import FIMUtils from '../im/FIMUtils';



export default class ROOMS2C extends INetHandler {
  name() {
    return 'ROOMS2C';
  }

  array = [];
  index = 0;
  lastTime = 0;

  constructor() {
    super();
  }

  handle(cmd, body, uin) {

    IMApp.is15None = false;
    if (cmd != net.CLIENT_MSG_ID.C2S_MSG_HEART) {
    } else {
      this.testHeart(body, uin);
      return true;
    }
    this.handleReal(cmd, body, uin);
  }

  handleReal(cmd, body, uin) {
    // console.log(cmd); //1306
    switch (cmd) {
      
      case net.CLIENT_MSG_ID.S2C_MSG_H5LOGIN_REP:
        this.msg_h5login_rep(body, uin);
        return true;
      case net.CLIENT_MSG_ID.S2C_MSG_PCLOGIN_REP:
        this.msg_pclogin_rep(body, uin);
        return true;

      case net.CLIENT_MSG_ID.S2C_MSG_GET_CHATROOM_LIST_REP:
        this.msg_get_chatroom_list_rep(body, uin);
        return true;
      case net.CLIENT_MSG_ID.S2C_MSG_GET_CHATROOM_MEMBERS_REP:
        this.msg_get_chatroom_members_rep(body, uin);
        return true;
      case net.CLIENT_MSG_ID.S2C_MSG_JOIN_CHATROOM_REP:
        this.msg_join_chatroom_rep(body, uin);
        return true;
      case net.CLIENT_MSG_ID.S2C_MSG_QUIT_CHATROOM_REP:
        this.msg_quit_chatroom_rep(body, uin);
        return true;
      case net.CLIENT_MSG_ID.S2C_MSG_SEND_CHATROOM_MSG_REP:
        this.msg_send_chatroom_msg_rep(body, uin);
        return true;
      case net.CLIENT_MSG_ID.S2C_MSG_CHATROOM_KICKOUT_REP:
        this.msg_chatroom_kickout_rep(body, uin);
        return true;
      case net.CLIENT_MSG_ID.S2C_MSG_CHATROOM_FORBID_REP:
        this.msg_chatroom_forbid_rep(body, uin);
        return true;
      case net.CLIENT_MSG_ID.S2C_MSG_CHATROOM_SET_ADMIN_REP:
        this.msg_chatroom_admin_rep(body, uin);
        return true;
      case net.CLIENT_MSG_ID.S2C_MSG_DEL_CHATROOM_MSG_REP:
        this.msg_del_chatroom_msg_rep(body, uin);
        return true;
      case net.CLIENT_MSG_ID.S2C_MSG_JOIN_CHATROOM_NTY:
        this.msg_join_chatroom_nty(body, uin);
        return true;
      case net.CLIENT_MSG_ID.S2C_MSG_GET_CHATROOM_HISTORY_MSG_REP:
        this.msg_get_chatroom_htstory_msg_ret(body, uin);
        return true;
    }
    return false;
  }


  testHeart(body, uin) {
    var msg = net.msg_heart_test.decode(body);
    let date = new Date();
    GameSocket.instance.timeDvl = msg.svrTime - date.getTime() / 1000 + 0.2;
    IMApp.server_time = msg.ms_time / 1000;
    IMApp.localTime = IMApp.currentTime();
  }




  msg_get_chatroom_htstory_msg_ret(body, uin) {
    let msgs = net.msg_get_chatroom_history_msg_rep.decode(body);
    msgs = msgs.msg_list

    for (let i = 0; i < msgs.length; i++) {
      msgs[i].content = StringUtils.decode(msgs[i].content)
      msgs[i].nickname = StringUtils.decode(msgs[i].nickname)
    }
    SingleCountEmitter.emit(IMEvent.S2C_MSG_GET_CHATROOM_HISTORY_MSG_REP, msgs);
  }


  msg_add_friend_byfid_rep(body, uin) {
    let msg = net.msg_add_friend_byfid_rep.decode(body);
    SingleCountEmitter.emit('S2C_MSG_ADD_FRIEND_BYFID_REP', msg);
  }


  msg_join_chatroom_nty(body, uin) {
    //通知xxx进入了直播间 
    var msg = net.msg_join_chatroom_nty.decode(body);
    const obj = {
      'msgtype': 999,
      'content': StringUtils.decode(msg.base_data.nickname),
      'chatkey': msg.roomkey,
      'viplevel': msg.base_data.viplevel
    }
    IMEventEmitter.emit(IMEvent.CHAT_ROOM_ZHA, obj)
  }

  msg_join_chatroom_rep(body, uin) {
    var msg = net.msg_join_chatroom_rep.decode(body);
    msg.room_info.roomname = StringUtils.decode(msg.room_info.roomname);
    msg.room_info.pic = StringUtils.decode(msg.room_info.pic);
    IMEventEmitter.emit(IMEvent.JOIN_ROOM_CHAT_REP, msg)

  }

  msg_quit_chatroom_rep(body, uin) {
    var msg = net.msg_join_chatroom_rep.decode(body);
    IMEventEmitter.emit(IMEvent.QUIT_ROOM_CHAT_REP, msg)
  }

  //聊天室撤回消息
  msg_del_chatroom_msg_rep(body, uin) {
    var msg = net.msg_del_chatroom_msg_rep.decode(body);
    // console.log(msg);
    // S2C_MSG_DEL_CHATROOM_MSG_REP
    IMEventEmitter.emit(IMEvent.S2C_MSG_DEL_CHATROOM_MSG_REP, msg)
  }

  msg_chatroom_admin_rep(body, uin) {

  }

  msg_chatroom_forbid_rep(body, uin) {

  }

  msg_chatroom_kickout_rep(body, uin) {
    var msg = net.msg_chatroom_kickout_rep.decode(body);
  }

  msg_send_chatroom_msg_rep(body, uin) {
    var msg = net.msg_send_chatroom_msg_rep.decode(body);
    let d = msg.msg_info;
    d.content = StringUtils.decode(d.content);
    d.otherid = IMApp.getOtherId(msg.msg_info.chatkey, msg.msg_info.uid);
    d.isGroup = true;
    d.nickname = StringUtils.decode(d.nickname);


    d.headurl = StringUtils.decode(d.headurl);
    d.msgState = 3;
    d.isLoaded = true;
    IMEventEmitter.emit(IMEvent.UPDATE_CONVERSATION_LIST);
    IMEventEmitter.emit(IMEvent.EVENT_MESSAGE_RECEIVED, [d]);
  }

  msg_get_chatroom_members_rep(body, uin) {
    var msg = net.msg_get_chatroom_members_rep.decode(body);
  }


  msg_get_chatroom_list_rep(body, uin) {
    var msg = net.msg_get_chatroom_list_rep.decode(body);
    IMEventEmitter.emit(IMEvent.CHAT_ROOM_LIST, msg)
  }


  

  msg_h5login_rep(body, uin) {
    let msg = net.msg_pclogin_rep.decode(body);
    // IMEventEmitter.emit(IMEvent.REF_ROOM);
    IMEventEmitter.emit(IMEvent.REF_ROOM);

  }

  

  

  

  


}
